import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { DashboardStats } from 'types';

interface DashboardState {
  stats: DashboardStats | null;
}

const initialState: DashboardState = {
  stats: null,
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardStats: (state, action: PayloadAction<DashboardStats>) => {
      state.stats = action.payload;
    },
  },
});

export const { setDashboardStats } = dashboardSlice.actions;

export const selectDashboardStats = (state: RootState) => state.dashboard.stats;

export default dashboardSlice.reducer;